module.exports = __webpack_public_path__ + "img/leiden_ie.bf5c0e6a.jpg";